// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TagIcon {
  display: flex;
  align-items: center;
  gap: 2px;
  border-radius: 8px;
  background-color: var(--color_neutral_900);
  padding: 8px 16px;
}
.TagIcon .TagIcon-text {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: var(--color_neutral_0);
  width: 100%;
}
.TagIcon-withIcon {
  padding: 8px 16px 8px 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/TagIcon/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,0CAAA;EACA,iBAAA;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,WAAA;AACJ;AAEE;EACE,yBAAA;AAAJ","sourcesContent":[".TagIcon {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  border-radius: 8px;\n  background-color: var(--color_neutral_900);\n  padding: 8px 16px;\n\n  .TagIcon-text {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 18px;\n    color: var(--color_neutral_0);\n    width: 100%;\n  }\n\n  &-withIcon {\n    padding: 8px 16px 8px 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
